import React from 'react'
import './settings-style.scss'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import useReportsStyles from './styles'
import Tab from '@mui/material/Tab'
import TabContext from '@mui/lab/TabContext'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import LogReport from '../LogReport'
import UserListing from '../UserListing'
import AddInternalUsers from './components/AddInternalUsers'
import InternalUserlist from '../InternalUserlist'
import AddExternalUserspage from './components/AddExternalUserspage/AddExternalUserspage'
import ChangePasswordPage from './components/ChangePasswordPage/ChangePasswordPage'
import UserInfo from './components/UserInfo/userInfo'
import EmailSettings from './components/EmailSettings'
import RolesList from './components/MasterData/RolesList';
import OrganizationsList from './components/MasterData/OrganizationsList';
import EntitiesList from './components/MasterData/EntitiesList';
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import Divider from '@mui/material/Divider'
import Typography from '@mui/material/Typography'

const SettingsDesktop = ({ logic }) => {
  const classes = useReportsStyles()

  // Destructure logic from hook
  const {
    value,
    userlistvalue,
    filterType,
    userAddvalue,
    tabsToShow,
    token,
    handlers,
    setters
  } = logic

  const { handleChange, handleUserlistTabChange, handleUserAddTabChange } = handlers
  const { setFilterType } = setters

  // Handler wrapper to match original prop naming if passed down
  const handleTabChange = handleChange

  return (
    <div className={classes.root}>
      <Box>
        <Grid container spacing={2}>
          <Grid item xs={12} md={12}>
            <div className="graph_bg">
              <h5>Settings</h5>
              <hr />
              <Box>
                <Grid container spacing={2}></Grid>
                <div>
                  <TabContext value={value}>
                    <Box style={{ display: 'flex', minHeight: '400px' }}>
                      <Box className="page_h_b2" style={{ width: '20%' }}>
                        <TabList
                          onChange={handleTabChange}
                          aria-label="lab API tabs example"
                          orientation="vertical"
                          variant="scrollable"
                          sx={{
                            '&& .MuiTab-root': {
                              alignItems: 'baseline',
                            },
                          }}
                        >
                          {tabsToShow.map((tab) => (
                            <Tab
                              key={tab.value}
                              classes={{
                                root: 'MuiButtonBase-root-MuiTab-root',
                              }}
                              label={tab.label}
                              value={tab.value}
                              style={{
                                backgroundColor:
                                  value === tab.value
                                    ? 'rgb(85 164 242 / 11%)'
                                    : 'white',
                              }}
                            />
                          ))}
                        </TabList>
                      </Box>

                      <Box className="page_h_b2" style={{ width: '80%' }}>
                        {/* Render content generic way based on active value */}
                        {value === '1' && (
                          <TabPanel value="1">
                            <Box
                              sx={{
                                '& .MuiTextField-root': {
                                  m: 1,
                                  width: '100%',
                                },
                              }}
                              md={8}
                              noValidate
                              autoComplete="off"
                            >
                              <TabContext value={userlistvalue}>
                                <Box
                                  className="page_h_b2"
                                  style={{
                                    width: '100%',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    borderBottom: '1px solid #e8e8e8'
                                  }}
                                >
                                  <TabList
                                    onChange={handleUserlistTabChange}
                                    aria-label="Userlist API tabs example"
                                    sx={{ minHeight: '48px' }}
                                  >
                                    <Tab
                                      classes={{
                                        root: 'MuiButtonBase-root-MuiTab-root',
                                      }}
                                      label="Internal Users"
                                      value="1"
                                    />
                                    <Tab
                                      classes={{
                                        root: 'MuiButtonBase-root-MuiTab-root',
                                      }}
                                      label="External Users"
                                      value="2"
                                    />
                                  </TabList>

                                  {userlistvalue === '2' && (
                                    <Box sx={{ pr: 2, display: 'flex', alignItems: 'center' }}>
                                      <FormControl variant="standard" sx={{ m: 1, minWidth: 140 }}>
                                        <InputLabel id="type-filter-label">Filter by Type</InputLabel>
                                        <Select
                                          labelId="type-filter-label"
                                          id="type-filter"
                                          value={filterType || 'all'}
                                          onChange={(e) => setFilterType(e.target.value)}
                                          label="Filter by Type"
                                        >
                                          <MenuItem value="all">All</MenuItem>
                                          <MenuItem value="client">Clients</MenuItem>
                                          <MenuItem value="investor">Investors</MenuItem>
                                          <MenuItem value="vendor">Vendors</MenuItem>
                                        </Select>
                                      </FormControl>
                                    </Box>
                                  )}
                                </Box>
                                <Box
                                  className="page_h_b2"
                                  style={{ width: '100%' }}
                                >
                                  <TabPanel value="1">
                                    <InternalUserlist logic={logic} />
                                  </TabPanel>
                                  <TabPanel value="2">
                                    <UserListing logic={logic} />
                                  </TabPanel>
                                </Box>
                              </TabContext>
                            </Box>
                          </TabPanel>
                        )}

                        {value === '2' && (
                          <TabPanel value="2">
                            <Box
                              sx={{
                                '& .MuiTextField-root': {
                                  m: 1,
                                  width: '100%',
                                },
                              }}
                              noValidate
                              autoComplete="off"
                            >
                              <TabContext value={userAddvalue}>
                                <Box
                                  className="page_h_b2"
                                  style={{ width: '100%' }}
                                >
                                  <TabList
                                    onChange={handleUserAddTabChange}
                                    aria-label="Userlist API tabs example"
                                  >
                                    <Tab
                                      classes={{
                                        root: 'MuiButtonBase-root-MuiTab-root',
                                      }}
                                      label="Internal Users"
                                      value="1"
                                    />
                                    <Tab
                                      classes={{
                                        root: 'MuiButtonBase-root-MuiTab-root',
                                      }}
                                      label="External Users"
                                      value="2"
                                    />
                                  </TabList>
                                </Box>
                                <Box
                                  className="page_h_b2"
                                  style={{ width: '100%' }}
                                >
                                  <TabPanel value="1">
                                    <AddInternalUsers
                                      logic={logic}
                                      handleTabChange={handleTabChange}
                                    />
                                  </TabPanel>
                                  <TabPanel value="2">
                                    <AddExternalUserspage
                                      logic={logic}
                                      handleTabChange={handleTabChange}
                                      handleUserlistTabChange={
                                        handleUserlistTabChange
                                      }
                                    />
                                  </TabPanel>
                                </Box>
                              </TabContext>
                            </Box>
                          </TabPanel>
                        )}

                        {value === '3' && <TabPanel value="3"><OrganizationsList /></TabPanel>}
                        {value === '4' && <TabPanel value="4"><RolesList /></TabPanel>}
                        {value === '5' && <TabPanel value="5"><EntitiesList /></TabPanel>}
                        {value === '6' && <TabPanel value="6"><LogReport token={token} /></TabPanel>}
                        {value === '7' && (
                          <TabPanel value="7">
                            <Box
                              sx={{
                                '& .MuiTextField-root': { mt: 1, width: '100%' },
                              }}
                              noValidate
                              autoComplete="off"
                            >
                              <ChangePasswordPage />
                            </Box>
                          </TabPanel>
                        )}
                        {value === '8' && <TabPanel value="8"><EmailSettings /></TabPanel>}
                        {value === '9' && <TabPanel value="9"><UserInfo /></TabPanel>}
                      </Box>
                    </Box>
                  </TabContext>
                </div>
              </Box>
            </div>
          </Grid>
        </Grid>
      </Box>
    </div>
  )
}

export default SettingsDesktop
